import styled from '@emotion/styled';
import { Stack, Flex } from '@pairy/pds-react';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const StackWrapper = styled(Stack)<{ isMobileLandscape: boolean }>`
  z-index: ${VIEWER_Z_INDEX.mobileLayer};
  width: auto;
  height: 43px;

  flex: 0 0 0px;

  background-color: ${({ isMobileLandscape }) =>
    isMobileLandscape ? 'transparent' : ''};
  opacity: 1;
  transition: opacity 0.15s ease-in-out;
`;

export const FlexCurrentPageTextWrapper = styled(Flex)`
  width: auto;
  min-width: 32px;

  height: 23px;
  padding: 4px;

  background: ${theme.colors.zinc_100};
  border-radius: 4px;
  color: ${theme.colors.black};
`;

export const Input = styled.input`
  width: 32px;
  height: 23px;
  padding: 4px;
  appearance: textfield;
  background: ${theme.colors.zinc_100};
  border-radius: 4px;
  color: ${theme.colors.black};

  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  outline: none;
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    margin: 0;
    appearance: none;
  }
`;
